import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';

export interface IDropDownOptions {
    id: string | number,
    value: string
}
interface IProps extends UseControllerProps {
    items: IDropDownOptions[];
    label?: string;
    size?: "small" | "medium";
    row?: boolean;
    onChange?: (value : string) => void;
}
const AppRadioButtons = (props: IProps) => {
    const { fieldState, field } = useController({ ...props })
    return (
        <FormControl error={!!fieldState.error}>
            <FormLabel id="demo-radio-buttons-group-label">{props.label ? props.label : null}</FormLabel>
            <RadioGroup
                row={props.row}
                value={field.value !== undefined ? field.value : null}
                name="radio-buttons-group"
                onChange={(e , value) => {
                    field.onChange(e);
                    props.onChange?.(value);
                }}>

                {props.items.map((item) => (
                    <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.value} />
                ))}

            </RadioGroup>
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>

    )
}

export default AppRadioButtons